import React from 'react';
import { JuniorHubScreen } from '../../components/home/JuniorHubScreen';
import { MELODIA_ITEMS } from '../../lib/juniorTheme';

export default function MelodiaHubPage() {
  return (
    <JuniorHubScreen
      eyebrow="Melodía"
      title="Cantar y tocar"
      subtitle="Melodías sencillas y canciones infantiles para explorar."
      emoji="🎵"
      accent="violet"
      items={MELODIA_ITEMS}
    />
  );
}
